export default "__VITE_ASSET__517aa40b__"